import { useSessionStore } from '@/store/useSessionStore';
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import paths from './paths';

const withSlash = (path: string) => `/${path}`

export const routes: Array<RouteRecordRaw> = [
  {
    path: paths.home,
    alias: '/',
    name: 'Home',
    component: () => import('../views/Home/Home.vue'),
  },
  {
    path: paths.login,
    name: 'Entrar',
    component: () => import('../views/Login/Login.vue')
  },
  {
    path: paths.register,
    name: 'Cadastro',
    component: () => import('../views/Register/Register.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: paths.scan,
    name: 'Escanear',
    component: () => import('../views/ScanCode/ScanCode.vue'),
  },
  {
    path: `${paths.gas_station}/:id`,
    name: 'Detalhe do Posto',
    props: true,
    component: () => import('../views/GasStationDetail.vue'),
  },
  {
    path: `/caption`,
    name: 'Caption',
    props: true,
    component: () => import('../views/Captions.vue'),
  },
  {
    path: paths.more.root,
    name: 'Mais',
    component: () => import('../views/Tabs/MoreTab.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        component: () => import('../views/More.vue'),
      },
      {
        path: 'termos-de-uso',
        component: () => import('../views/AppTerms.vue'),
      },
      {
        path: 'suporte',
        component: () => import('../views/AppHelp.vue'),
      },

    ]
  },
  {
    path: paths.chargings.root,
    name: 'Carregamentos',
    component: () => import('../views/Tabs/ChargingsTab.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        component: () => import('../views/ChargingsList.vue'),
      },
      {
        path: `detalhe/:id`,
        props: true,
        component: () => import('../views/ChargingDetail/ChargingDetail.vue'),
      },
    ]
  },
  {
    path: paths.not_logged,
    name: 'Deslogado',
    component: () => import('../views/NotLogged.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {

  const session = useSessionStore().session

  if (!to.meta.requiresAuth) { return next() } // nao precisa de login
  if (!session) { // nao esta logado
    return next(paths.not_logged);
  }
  if (session.is_registration_complete) {
    if (to.path == paths.register) {
      return next(paths.home)
    }
    return next()
  }
  if (to.path == paths.register) {
    return next()
  }
  return next(paths.not_logged)
});

export default router
